import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/Permissions.css';


const Permissions = () => {
    const [users, setUsers] = useState([]);
    const [error, setError] = useState('');
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${API_BASE_URL}/admin/users`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setUsers(response.data);
            } catch (error) {
                setError('Failed to fetch users.');
            }
        };
        fetchUsers();
    }, []);

    const handlePermissionChange = async (userId, permissionType, value) => {
        try {
            const token = localStorage.getItem('token');
            await axios.put(
                `${API_BASE_URL}/admin/users/${userId}/permissions`,
                { permissionType, value },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setUsers(
                users.map((user) =>
                    user.id === userId
                        ? {
                              ...user,
                              permissions: {
                                  ...user.permissions,
                                  [permissionType]: value,
                              },
                          }
                        : user
                )
            );
        } catch (error) {
            console.error('Error updating permissions:', error);
            setError('Failed to update permissions.');
        }
    };

    const downloadPermissionsCSV = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_BASE_URL}/admin/permissions/csv`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'permissions.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            setError('Error downloading Permissions CSV');
        }
    };
    
    const downloadPermissionsExcel = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_BASE_URL}/admin/permissions/excel`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'permissions.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            setError('Error downloading Permissions Excel');
        }
    };

    return (
        <div className="permissions-section">
            <h2>User Permissions</h2>
            <div className="export-buttons">
    <button onClick={downloadPermissionsCSV}>Download Permissions CSV</button>
    <button onClick={downloadPermissionsExcel}>Download Permissions Excel</button>
</div>

            {error && <p className="error">{error}</p>}
            
            {/* Loop through users and display each user in a card */}
            {users.map((user) => (
                <div key={user.id} className="user-card">
                    <div className="user-header">
                        <h3>{user.email}</h3>
                        <span className="user-email">{user.email}</span>
                    </div>
                    
                    <div className="permissions-list">
                        <div className="permission-item">
                            <label className="permission-label">Add Product</label>
                            <input
                                type="checkbox"
                                checked={user.permissions.add_product}
                                onChange={(e) =>
                                    handlePermissionChange(user.id, 'add_product', e.target.checked)
                                }
                            />
                        </div>
                        <div className="permission-item">
                            <label className="permission-label">Update Product</label>
                            <input
                                type="checkbox"
                                checked={user.permissions.update_product}
                                onChange={(e) =>
                                    handlePermissionChange(user.id, 'update_product', e.target.checked)
                                }
                            />
                        </div>
                        <div className="permission-item">
                            <label className="permission-label">Delete Product</label>
                            <input
                                type="checkbox"
                                checked={user.permissions.delete_product}
                                onChange={(e) =>
                                    handlePermissionChange(user.id, 'delete_product', e.target.checked)
                                }
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Permissions;
